import { Model } from '@vuex-orm/core'

import Journal from './Journal'

export default class Subject extends Model {
  static entity = 'subjects'

  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      workspace_id: this.attr(null),
      topic: this.attr(null),
      journal: this.belongsTo(Journal, 'journal_id'),
      tags: this.attr(null),
      withdrawal: this.attr(null),
      journal_id: this.attr(null),
      modified_at: this.attr(null),
    }
  }
}
